import React from "react"
import { DataUploadNotification } from "~Components/layout/partials/dataUploadNotification"

export const GlobalNotifications = () => (
    <>
        <DataUploadNotification />
    </>
)
